/**
 * IFSC银行代码映射工具
 * 用于将IFSC代码前缀映射到银行名称
 * 包含完整的印度银行IFSC代码映射表
 */

// IFSC银行代码映射表（完整版 - 包含所有印度银行）
const IFSC_BANK_MAP = {
  AACX: 'Akhand Anand Co.op Bank',
  ABBL: 'AB Bank',
  ABCX: 'Aurangabad District Central Co-operative Bank',
  ABDX: 'Dr. Ambedkar Nagrik Sahakari Bank Mydt Gwalior',
  ABEX: 'Andhra Bank Employees Co-operative Bank',
  ABHY: 'Abhyudaya Co-operative Bank',
  ABNA: 'Royal Bank of Scotland N.V.',
  ABPB: 'Aditya Birla Idea Payments Bank',
  ABSB: 'Abhinav Sahakari Bank',
  ABUX: 'Abhinandan Urban Co-operative Bank Amravati',
  ACAX: 'Assam Co-operative Apex Bank',
  ACBX: 'Adarsh Co-operative Bank',
  ACCX: 'Ace Co-operative Bank',
  ACKX: 'Annasaheb Chougule Urban Co-operative Bank',
  ACOX: 'Amarnath Co-operative Bank',
  ACUB: 'Aryapuram Co-operative Urban Bank',
  ACUX: 'Adarsh Co-operative Urban Bank',
  ADBX: 'Ahmedabad District Co-operative Bank',
  ADCB: 'Abu Dhabi Commercial Bank',
  ADCC: 'Akola District Central Co-operative Bank',
  ADCX: 'Shri Adinath Co-operative Bank',
  ADDX: 'Adilabad District Co-operative Central Bank',
  AGCX: 'Agrasen Co-operative Urban Bank',
  AGDX: 'Agra District Co-operative Bank',
  AGRX: 'Agroha Co-operative Urban Bank',
  AGSX: 'Agrasen Nagari Sahakari Bank',
  AGUX: 'Agartala Co-operative Urban Bank',
  AGVX: 'Assam Gramin Vikash Bank',
  AHDC: 'Ahmednagar District Central Co-operative Bank',
  AHMX: 'Ahmednagar District Central Co-operative Bank',
  AHUX: 'Ahilyadevi Urban Co-operative Bank Solapur',
  AIRP: 'Airtel Payments Bank',
  AJAR: 'Ajara Urban Co-operative Bank',
  AJHC: 'Ambarnath Jai-hind Co-operative Bank',
  AJKB: 'Akola Janata Commercial Co-operative Bank',
  AJMX: 'Ajmer Central Co-operative Bank',
  AJNX: 'Ajantha Urban Co-operative Bank',
  AJPX: 'Ambajogai Peoples Co-operative Bank',
  AJSX: 'Ambarnath Jai-hind Co-operative Bank',
  AJUX: 'Ajara Urban Co-operative Bank',
  AKJB: 'Akola Janata Commercial Co-operative Bank',
  AKKB: 'Akkamahadevi Mahila Sahakari Bank Niyamit',
  AKMX: 'Akola Merchant Co-operative Bank',
  AKOX: 'Akola Urban Co-operative Bank',
  ALAX: 'Alavi Co-operative Bank',
  ALIX: 'Aligarh District Co-operative Bank',
  ALLA: 'Allahabad Bank',
  ALLX: 'Allahabad District Co-operative Bank',
  ALWX: 'Alwar Central Co-operative Bank',
  AMAX: 'Aman Sahakari Bank',
  AMBX: 'Ambala Central Co-operative Bank',
  AMCB: 'Ahmedabad Mercantile Co-operative Bank',
  AMCX: 'Amritsar Central Co-operative Bank',
  AMDN: 'Ahmednagar Merchants Co-operative Bank',
  AMMX: 'Adarsh Mahila Mercantile Co-operative Bank',
  AMNX: 'Astha Mahila Nagrik Sahakari Bank Maryadit',
  AMRX: 'Amreli Jilla Madhyastha Sahakari Bank',
  AMSB: 'Annasaheb Magar Sahakari Bank',
  AMSX: 'Ambika Mahila Sahakari Bank',
  ANBX: 'Amreli Nagarik Sahakari Bank',
  ANDB: 'Andhra Bank',
  ANDX: 'Andarsul Urban Co-operative Bank',
  ANMX: 'Ahmednagar Merchant\'s Co-operative Bank',
  ANSX: 'Andaman & Nicobar State Co-operative Bank',
  ANUX: 'Anuradha Urban Co-operative Bank',
  ANZB: 'Australia and New Zealand Banking Group',
  APBL: 'Andhra Pradesh State Co-operative Bank',
  APCX: 'Alappuzha District Co-operative Bank',
  APGB: 'Andhra Pragathi Grameena Bank',
  APGV: 'Andhra Pradesh Grameena Vikas Bank',
  APGX: 'Andhra Pradesh Grameena Vikas Bank',
  APJX: 'Ap Janata Co-operative Urban Bank',
  APMC: 'A.P. Mahesh Co-operative Urban Bank',
  APMX: 'Ap Mahajan\'s Co-operative Urban Bank',
  APNX: 'Apani Sahakari Bank',
  APRR: 'A.P. Raja Rajeswari Mahila Co-operative Urban Bank',
  APRX: 'Arunachal Pradesh Rural Bank',
  APSX: 'P. D. Patilsaheb Sahakari Bank',
  ARBL: 'Arvind Sahakari Bank',
  ARCX: 'Arunachal Pradesh State Co-operative Apex Bank',
  ARMX: '510 Army Base W/s Credit Co-operative Primary Bank',
  ARYX: 'Gramin Bank of Aryavart',
  ASBL: 'Apna Sahakari Bank',
  ASBX: 'Ahmednagar Shahar Sahakari Bank Maryadit',
  ASHX: 'Ashta People\'s Co-operative Bank',
  ASKX: 'Arvind Sahakari Bank',
  ASNX: 'Ashoknagar Co-operative Bank',
  ASOX: 'Associate Co-operative Bank',
  ASSX: 'Ashok Sahakari Bank',
  AUBL: 'AU Small Finance Bank',
  AUBX: 'Angul United Central Co-operative Bank',
  AUCB: 'Almora Urban Co-operative Bank',
  AUCX: 'Ajara Urban Co-operative Bank',
  AUGX: 'Allahabad Up Gramin Bank',
  AURX: 'Aurangabad District Central Co-operative Bank. Bihar',
  AVDX: 'Amravati District Central Co-operative Bank',
  AWCX: 'Alwaye Urban Co-operative Bank',
  AWUX: 'Alwar Urban Co-operative Bank',
  AZAX: 'Azad Co-operative Bank',
  AZPX: 'Amravati Zilla Parishad Shikshak Sahakari Bank',
  AZSX: 'Almora Zila d Bank',
  AZUX: 'Azad Urban Co-operative Bank Hubli',
  BACB: 'Bassein Catholic Co-operative Bank',
  BACX: 'Bihar Awami Co-operative Bank',
  BADX: 'Bankura District Central Co-operative Bank',
  BAGX: 'Balangir District Central Co-operative Bank',
  BALB: 'Bally Co-operative Bank',
  BALX: 'Balasinor Nagarik Sahakari Bank',
  BANX: 'Banaras Mercantile Co-operative Bank',
  BARA: 'Baramati Sahakari Bank',
  BARB: 'Bank of Baroda',
  BARC: 'Barclays Bank',
  BARX: 'Baroda City Co-operative Bank',
  BASX: 'Shri Basaveshwar Sahakari Bank Nyt.bagalkot',
  BAUX: 'Badagara Co-operative Urban Bank',
  BAVX: 'Bavla Nagrik Sahakari Bank',
  BAWX: 'Bhawanipatna Central Co-operative Bank',
  BBDX: 'Birbhum District Central Co-operative Bank',
  BBKM: 'Bank of Bahrein and Kuwait',
  BBLX: 'Bhingar Urban Co-operative Bank',
  BBRX: 'Bangalore Bangalore Rural&ramanagara Dccb',
  BBSX: 'Balasore Bhadrak Central Co-operative Bank',
  BBUX: 'Bellad Bagewadi Urban Souharada Sahakari Bank Nyt',
  BBVX: 'Bhabhar Vibhag Nagrik Sahakari Bank',
  BCBM: 'Bharat Co-operative Bank',
  BCBX: 'Bantra Co-operative Bank',
  BCCB: 'Bangalore City Co-operative Bank',
  BCCX: 'Bathinda Central Co-operative Bank',
  BCEX: 'Banswara Central Co-operative Bank',
  BCEY: 'Bank of Ceylon',
  BCOX: 'Bapuji Co-operative Bank',
  BCUB: 'Bicholim Urban Co-operative Bank',
  BCUX: 'Baghat Urban Co-operative Bank',
  BDBB: 'Bahraich District Co-operative Bank',
  BDBL: 'Bandhan Bank',
  BDBX: 'Bellary District Co-operative Central Bank',
  BDCX: 'Bijapur District Central Co-operative Bank',
  BDDX: 'Bhadradri Co-operative Urban Bank',
  BDIX: 'Bhandara District Central Co-operative Bank',
  BDNX: 'Bhind Nagrik Sahakari Bank Mydt',
  BDOX: 'Banda District Co-operative Bank',
  BDUX: 'Banda Urban Co-operative Bank',
  BEDX: 'Beed District Central Co-operative Bank',
  BELX: 'Belgaum District Central Co-operative Bank',
  BERX: 'Berhampore Co-operative Central Bank',
  BFUX: 'Bhagyodaya Friends Urban Co-operative Bank',
  BGBX: 'Dakshin Bihar Gramin Bank',
  BGCX: 'Balageria Central Co-operative Bank',
  BGGX: 'Baroda Gujarat Gramin Bank',
  BGUX: 'Begusarai Central Co-operative Bank',
  BGVX: 'Bangiya Gramin Vikash Bank',
  BHAX: 'Bhagyodaya Co-operative Bank',
  BHBX: 'Bhilai Nagarik Sahakari Bank Maryadit',
  BHCX: 'Bhuj Commercial Co-operative Bank',
  BHDX: 'Bhadohi Urban Co-operative Bank Gyanpur',
  BHEX: 'Bhel Employees Co-operative Bank',
  BHGX: 'Bhagalpur Central Co-operative Bank',
  BHIX: 'Bhilwara Mahila Urban Co-operative Bank',
  BHJX: 'Bhuj Mercentile Co-operative Bank',
  BHMX: 'Brahmadeodada Mane Sahakari Bank Solapur',
  BHOX: 'Bhopal Co-operative Central Bank',
  BHRX: 'Bharatpur Central Co-operative Bank',
  BHSX: 'Bharati Sahakari Bank',
  BHTX: 'Bhatkal Urban Co-operative Bank',
  BHUX: 'Bhilwara Urban Co-operative Bank',
  BHWX: 'Bhiwani Central Co-operative Bank Bhiwani',
  BJUX: 'Bijnor Urban Co-operative Bank',
  BKCX: 'Bhavasara Kshatriya Co-operative Bank',
  BKDN: 'Dena Bank',
  BKDX: 'Banaskantha District Central Co-operative Bank',
  BKID: 'Bank of India',
  BKSX: 'Baran Kendriya Sahakari Bank Baran',
  BLGX: 'Shree Basaveshwar Co-operative Bank',
  BMBL: 'Bharatiya Mahila Bank',
  BMCB: 'Bombay Mercantile Co-operative Bank',
  BMCX: 'Barmer Central Co-operative Bank',
  BMPX: 'Banaskantha Mercantile Co-operative Bank',
  BMSX: 'Bhagyalakshmi Mahila Sahakari Bank',
  BNBX: 'Betul Nagrik Sahakari Bank Mydt',
  BNCX: 'Bhatpara Naihati Co-operative Bank',
  BNKX: 'Banki Central Co-operative Bank',
  BNPA: 'BNP Paribas Bank',
  BNSB: 'Bhagini Nivedita Sahakari Bank Pune',
  BNSX: 'Bhagini Nivedita Sahakari Bank',
  BOCX: 'Boudh Co-operative Central Bank',
  BODX: 'Bagalkot District Central Co-operative Bank',
  BOFA: 'Bank of America',
  BORX: 'Boral Union Co-operative Bank',
  BOTM: 'MUFG Bank',
  BOTX: 'Shree Botad Mercantile Co-operative Bank',
  BPCX: 'Bhadgaon People\'s Co-operative Bank',
  BPSX: 'Bilagi Pattana Sahakari Bank Niyamit',
  BRCX: 'Bhavana Rishi Co-operative Urban Bank',
  BRDX: 'Baroda Central Co-operative Bank',
  BRGX: 'Baroda Rajasthan Kshetriya Gramin Bank',
  BRMX: 'Bramhapuri Urban Co-operative Bank',
  BRSX: 'Baran Nagrik Bank',
  BRUX: 'Bharuch District Central Co-operative Bank Bharuc',
  BSBX: 'Baramati Sahakari Bank',
  BSCX: 'Baidyabati Sheoraphuli Co-operative Bank',
  BTCX: 'Balitikuri Co-operative Bank',
  BTUX: 'Balotra Urban Co-operative Bank',
  BUBX: 'Bhandara Urban Co-operative Bank',
  BUCL: 'Belur Urban Co-operative Bank',
  BUCX: 'Beawar Urban Co-operative Bank',
  BUGX: 'Baroda Uttar Pradesh Gramin Bank',
  BUNX: 'Bundi Central Co-operative Bank',
  BURX: 'Burdwan Central Co-operative Bank',
  BUSX: 'Business Co-operative Bank',
  BUZX: 'Badaun Zila d Bank',
  BVNX: 'Bhavnagar District Co-operative Bank',
  BVSX: 'Bhavani Sahakari Bank',
  BWCX: 'Brahmawart Commercial Co-operative Bank',
  CBIN: 'Central Bank of India',
  CCBL: 'Citizen Credit Co-operative Bank',
  CHAS: 'JP Morgan Chase Bank NA',
  CITI: 'CITI Bank',
  CIUB: 'City Union Bank',
  CLBL: 'Capital Small Finance Bank',
  CNRB: 'Canara Bank',
  CORP: 'Corporation Bank',
  COSB: 'Cosmos Co-operative Bank',
  CRES: 'Credit Suisse AG',
  CTBA: 'Commonwealth Bank of Australia',
  CTCB: 'Chinatrust Commercial Bank',
  DBSS: 'Development Bank of Singapore',
  DCBL: 'DCB Bank',
  DEUT: 'Deutsche Bank',
  DNSB: 'Dombivli Nagari Sahakari Bank',
  DOHB: 'Doha Bank QSC',
  EBIL: 'Emirates NBD Bank',
  EIBI: 'Export Import Bank of India',
  ESAF: 'ESAF Small Finance Bank',
  ESFB: 'Equitas Small Finance Bank',
  ESMF: 'Esaf Small Finance Bank',
  FDRL: 'Federal Bank',
  FINO: 'Fino Payments Bank',
  FIRN: 'Firstrand Bank',
  FSFB: 'Fincare Small Finance Bank',
  HDFC: 'HDFC Bank',
  HSBC: 'Hongkong & Shanghai Banking Corporation',
  IBKL: 'IDBI',
  ICIC: 'ICICI Bank',
  IDFB: 'IDFC FIRST Bank',
  IDIB: 'Indian Bank',
  INDB: 'Indusind Bank',
  IOBA: 'Indian Overseas Bank',
  IPOS: 'India Post Payments Bank',
  IPPB: 'India Post Payments Bank',
  JAKA: 'Jammu and Kashmir Bank',
  JIOP: 'Jio Payments Bank',
  JSFB: 'Jana Small Finance Bank',
  KARB: 'Karnataka Bank',
  KKBK: 'Kotak Mahindra Bank',
  KVBL: 'Karur Vysya Bank',
  LAVB: 'Laxmi Vilas Bank',
  MAHB: 'Bank of Maharashtra',
  MHCB: 'Mizuho Bank',
  MSHQ: 'Mashreq Bank',
  NBAD: 'National Bank of Abu Dhabi PJSC',
  NBRD: 'National Bank for Agriculture and Development',
  NESF: 'North East Small Finance Bank',
  NOSC: 'Bank of Nova Scotia',
  NSPB: 'NSDL Payments Bank',
  ORBC: 'Oriental Bank of Commerce',
  PMCB: 'Punjab & Maharashtra Co-operative Bank',
  PRTH: 'Prathama Bank',
  PSIB: 'Punjab & Sind Bank',
  PUNB: 'Punjab National Bank',
  PYTM: 'Paytm Payments Bank',
  QNBA: 'Qatar National Bank',
  RABO: 'Rabobank International',
  RATN: 'RBL Bank',
  RBIN: 'Reserve Bank Of India',
  SBBJ: 'State Bank of Bikaner and Jaipur',
  SBHY: 'State Bank of Hyderabad',
  SBIN: 'State Bank of India',
  SBMY: 'State Bank of Mysore',
  SBTR: 'State Bank of Travancore',
  SCBL: 'Standard Chartered Bank',
  SIBL: 'South Indian Bank',
  SIDB: 'Small Industries Development Bank Of India',
  SMBC: 'Sumitomo Mitsui Banking Corporation',
  SOGE: 'Societe Generale',
  SRCB: 'Saraswat Co-operative Bank',
  SURY: 'Suryoday Small Finance Bank',
  SVCB: 'Shamrao Vithal Co-operative Bank',
  SYNB: 'Syndicate Bank',
  TMBL: 'Tamilnad Mercantile Bank',
  TNSC: 'Tamilnadu State Apex Co-operative Bank',
  UBIN: 'Union Bank of India',
  UCBA: 'UCO Bank',
  UJVN: 'Ujjivan Small Finance Bank',
  UOVB: 'United Overseas Bank',
  UTBI: 'United Bank of India',
  UTIB: 'Axis Bank',
  UTKS: 'Utkarsh Small Finance Bank',
  VIJB: 'Vijaya Bank',
  WPAC: 'Westpac Banking Corporation',
  YESB: 'Yes Bank'
}

/**
 * 根据IFSC代码前缀获取银行名称
 * @param {string} ifscCode - IFSC代码（可以是4位前缀或完整11位代码）
 * @returns {string} 银行名称，如果未找到返回'Unknown Bank'
 */
export function getBankNameByIFSC (ifscCode) {
  if (!ifscCode || typeof ifscCode !== 'string') {
    return 'Unknown Bank'
  }

  const prefix = ifscCode.substring(0, 4).toUpperCase()
  return IFSC_BANK_MAP[prefix] || 'Unknown Bank'
}

/**
 * 验证IFSC代码格式（支持4位前缀或11位完整代码）
 * @param {string} ifscCode - IFSC代码
 * @returns {boolean} 是否为有效的IFSC代码格式
 */
export function validateIFSCFormat (ifscCode) {
  if (!ifscCode || typeof ifscCode !== 'string') {
    return false
  }

  const code = ifscCode.toUpperCase().trim()

  // 支持4位前缀（只验证银行代码）
  if (code.length === 4) {
    const prefixPattern = /^[A-Z]{4}$/
    return prefixPattern.test(code)
  }

  // 支持11位完整IFSC代码
  if (code.length === 11) {
    const fullPattern = /^[A-Z]{4}[0-9A-Z]{7}$/
    return fullPattern.test(code)
  }

  return false
}

/**
 * 验证IFSC前缀是否存在于银行映射表中
 * @param {string} ifscCode - IFSC代码
 * @returns {boolean} 前缀是否存在
 */
export function validateIFSCPrefix (ifscCode) {
  if (!ifscCode || typeof ifscCode !== 'string') {
    return false
  }

  const prefix = ifscCode.substring(0, 4).toUpperCase()
  return IFSC_BANK_MAP.hasOwnProperty(prefix)
}

/**
 * 格式化IFSC代码（转换为标准大写格式）
 * @param {string} ifscCode - IFSC代码
 * @returns {string} 格式化后的IFSC代码
 */
export function formatIFSCCode (ifscCode) {
  if (!ifscCode || typeof ifscCode !== 'string') {
    return ''
  }

  return ifscCode.toUpperCase().trim()
}

/**
 * 获取所有支持的银行列表
 * @returns {Array} 银行列表数组，包含code和name
 */
export function getSupportedBanks () {
  return Object.entries(IFSC_BANK_MAP).map(([code, name]) => ({
    code,
    name
  }))
}

/**
 * 搜索银行（根据银行名称或代码）
 * @param {string} searchTerm - 搜索关键词
 * @returns {Array} 匹配的银行列表
 */
export function searchBanks (searchTerm) {
  if (!searchTerm || typeof searchTerm !== 'string') {
    return []
  }

  const term = searchTerm.toLowerCase()
  return Object.entries(IFSC_BANK_MAP)
    .filter(([code, name]) =>
      code.toLowerCase().includes(term) ||
      name.toLowerCase().includes(term)
    )
    .map(([code, name]) => ({ code, name }))
}

// 导出IFSC映射表（只读）
export const IFSC_BANK_MAPPING = Object.freeze({ ...IFSC_BANK_MAP })

export default {
  getBankNameByIFSC,
  validateIFSCFormat,
  validateIFSCPrefix,
  formatIFSCCode,
  getSupportedBanks,
  searchBanks,
  IFSC_BANK_MAPPING
}
